import type { Priority } from '../model/index.tsx';
import { getPriorityListForProject } from '../rest/index.tsx';
import type { RestPriorityResponse } from '../rest/types.tsx';

const transformPriority = (data: RestPriorityResponse): Priority[] =>
	data.map((priority) => ({
		value: priority.id,
		label: priority.name,
		iconUrl: priority.iconUrl,
	}));

const cachedResult: {
	[key: string]: Priority[];
} = {};

const resetCache = () => {
	Object.keys(cachedResult).forEach((key) => {
		delete cachedResult[key];
	});
};

export const requestProjectPriorityList = (projectId: string) =>
	cachedResult[projectId]
		? Promise.resolve(cachedResult[projectId])
		: getPriorityListForProject(projectId)
				.then(({ values }) => transformPriority(values))
				.then((result) => {
					cachedResult[projectId] = result;
					return result;
				});

export const exportedForTesting = {
	resetCache,
};
